const emojiList = {
  symbols: [
    '1f4af',
    '1f522',
    '1f441-200d-1f5e8',
    '1f498',
    '2764-fe0f',
    '1f493',
    '1f494',
    '1f495',
    '1f496',
    '1f497',
    '1f499',
    '1f49a',
    '1f49b',
    '1f49c',
    '1f5a4',
    '1f49d',
    '1f49e',
    '1f49f',
    '2763-fe0f',
    '1f4a2',
    '1f4a5',
    '1f4ab',
    '1f4ac',
    '1f5e8-fe0f',
    '1f5ef-fe0f',
    '1f4ad',
    '1f4ae',
    '1f310',
    '2668-fe0f',
    '1f6d1',
    '1f55b',
    '1f567',
    '1f550',
    '1f55c',
    '1f551',
    '1f55d',
    '1f552',
    '1f55e',
    '1f553',
    '1f55f',
    '1f554',
    '1f560',
    '1f555',
    '1f561',
    '1f556',
    '1f562',
    '1f557',
    '1f563',
    '1f558',
    '1f564',
    '1f559',
    '1f565',
    '1f55a',
    '1f566',
    '1f300',
    '2660-fe0f',
    '2665-fe0f',
    '2666-fe0f',
    '2663-fe0f',
    '1f0cf',
    '1f004-fe0f',
    '1f3b4',
    '1f507',
    '1f508',
    '1f509',
    '1f50a',
    '1f4e2',
    '1f4e3',
    '1f514',
    '1f515',
    '1f3b5',
    '1f3b6',
    '1f4b9',
    '1f4b1',
    '1f4b2',
    '1f3e7',
    '1f6ae',
    '1f6b0',
    '267f-fe0f',
    '1f6b9',
    '1f6ba',
    '1f6bb',
    '1f6bc',
    '1f6be',
    '1f6c2',
    '1f6c3',
    '1f6c4',
    '1f6c5',
    '26a0-fe0f',
    '1f6b8',
    '26d4-fe0f',
    '1f6ab',
    '1f6b3',
    '1f6ad',
    '1f6af',
    '1f6b1',
    '1f6b7',
    '1f4f5',
    '1f51e',
    '2622-fe0f',
    '2623-fe0f',
    '2b06-fe0f',
    '2197-fe0f',
    '27a1-fe0f',
    '2198-fe0f',
    '2b07-fe0f',
    '2199-fe0f',
    '2b05-fe0f',
    '2196-fe0f',
    '2195-fe0f',
    '2194-fe0f',
    '21a9-fe0f',
    '21aa-fe0f',
    '2934-fe0f',
    '2935-fe0f',
    '1f503',
    '1f504',
    '1f519',
    '1f51a',
    '1f51b',
    '1f51c',
    '1f51d',
    '1f6d0',
    '269b-fe0f',
    '1f549-fe0f',
    '2721-fe0f',
    '2638-fe0f',
    '262f-fe0f',
    '271d-fe0f',
    '2626-fe0f',
    '262a-fe0f',
    '262e-fe0f',
    '1f54e',
    '1f52f',
    '2648-fe0f',
    '2649-fe0f',
    '264a-fe0f',
    '264b-fe0f',
    '264c-fe0f',
    '264d-fe0f',
    '264e-fe0f',
    '264f-fe0f',
    '2650-fe0f',
    '2651-fe0f',
    '2652-fe0f',
    '2653-fe0f',
    '26ce',
    '1f500',
    '1f501',
    '1f502',
    '25b6-fe0f',
    '23e9',
    '23ed-fe0f',
    '23ef-fe0f',
    '25c0-fe0f',
    '23ea',
    '23ee-fe0f',
    '1f53c',
    '23eb',
    '1f53d',
    '23ec',
    '23f8-fe0f',
    '23f9-fe0f',
    '23fa-fe0f',
    '23cf-fe0f',
    '1f3a6',
    '1f505',
    '1f506',
    '1f4f6',
    '1f4f3',
    '1f4f4',
    '267b-fe0f',
    '1f4db',
    '269c-fe0f',
    '1f530',
    '1f531',
    '2b55-fe0f',
    '2705',
    '2611-fe0f',
    '2714-fe0f',
    '2716-fe0f',
    '274c',
    '274e',
    '2795',
    '2796',
    '2797',
    '27b0',
    '27bf',
    '303d-fe0f',
    '2733-fe0f',
    '2734-fe0f',
    '2747-fe0f',
    '203c-fe0f',
    '2049-fe0f',
    '2753',
    '2754',
    '2755',
    '2757-fe0f',
    '3030-fe0f',
    '00a9-fe0f',
    '00ae-fe0f',
    '2122-fe0f',
    '0023-fe0f-20e3',
    '002a-fe0f-20e3',
    '0030-fe0f-20e3',
    '0031-fe0f-20e3',
    '0032-fe0f-20e3',
    '0033-fe0f-20e3',
    '0034-fe0f-20e3',
    '0035-fe0f-20e3',
    '0036-fe0f-20e3',
    '0037-fe0f-20e3',
    '0038-fe0f-20e3',
    '0039-fe0f-20e3',
    '1f51f',
    '1f520',
    '1f521',
    '1f523',
    '1f524',
    '1f170',
    '1f18e',
    '1f171',
    '1f191',
    '1f192',
    '1f193',
    '2139-fe0f',
    '1f194',
    '24c2-fe0f',
    '1f195',
    '1f196',
    '1f17e',
    '1f197',
    '1f17f-fe0f',
    '1f198',
    '1f199',
    '1f19a',
    '1f201',
    '1f202-fe0f',
    '1f237-fe0f',
    '1f236',
    '1f22f-fe0f',
    '1f250',
    '1f239',
    '1f21a-fe0f',
    '1f232',
    '1f251',
    '1f238',
    '1f234',
    '1f233',
    '3297-fe0f',
    '3299-fe0f',
    '1f23a',
    '1f235',
    '25aa-fe0f',
    '25ab-fe0f',
    '25fb-fe0f',
    '25fc-fe0f',
    '25fd-fe0f',
    '25fe-fe0f',
    '2b1b-fe0f',
    '2b1c-fe0f',
    '1f536',
    '1f537',
    '1f538',
    '1f539',
    '1f53a',
    '1f53b',
    '1f4a0',
    '1f518',
    '1f532',
    '1f533',
    '26aa-fe0f',
    '26ab-fe0f',
    '1f534',
    '1f535',
  ],
  people: [
    '1f600',
    '1f601',
    '1f602',
    '1f923',
    '1f603',
    '1f604',
    '1f605',
    '1f606',
    '1f609',
    '1f60a',
    '1f60b',
    '1f60e',
    '1f60d',
    '1f618',
    '1f617',
    '1f619',
    '1f61a',
    '263a-fe0f',
    '1f642',
    '1f917',
    '1f914',
    '1f610',
    '1f611',
    '1f636',
    '1f644',
    '1f60f',
    '1f623',
    '1f625',
    '1f62e',
    '1f910',
    '1f62f',
    '1f62a',
    '1f62b',
    '1f634',
    '1f60c',
    '1f913',
    '1f61b',
    '1f61c',
    '1f61d',
    '1f924',
    '1f612',
    '1f613',
    '1f614',
    '1f615',
    '1f643',
    '1f911',
    '1f632',
    '2639-fe0f',
    '1f641',
    '1f616',
    '1f61e',
    '1f61f',
    '1f624',
    '1f622',
    '1f62d',
    '1f626',
    '1f627',
    '1f628',
    '1f629',
    '1f62c',
    '1f630',
    '1f631',
    '1f633',
    '1f635',
    '1f621',
    '1f620',
    '1f607',
    '1f920',
    '1f921',
    '1f925',
    '1f637',
    '1f912',
    '1f915',
    '1f922',
    '1f927',
    '1f608',
    '1f47f',
    '1f479',
    '1f47a',
    '1f480',
    '1f47b',
    '1f47d',
    '1f916',
    '1f4a9',
    '1f63a',
    '1f638',
    '1f639',
    '1f63b',
    '1f63c',
    '1f63d',
    '1f640',
    '1f63f',
    '1f63e',
    '1f46f',
    '1f5e3-fe0f',
    '1f464',
    '1f465',
    '1f46b',
    '1f46c',
    '1f46d',
    '1f48f',
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468',
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469',
    '1f491',
    '1f468-200d-2764-fe0f-200d-1f468',
    '1f469-200d-2764-fe0f-200d-1f469',
    '1f46a',
    '1f468-200d-1f469-200d-1f467',
    '1f468-200d-1f469-200d-1f467-200d-1f466',
    '1f468-200d-1f469-200d-1f466-200d-1f466',
    '1f468-200d-1f469-200d-1f467-200d-1f467',
    '1f468-200d-1f468-200d-1f466',
    '1f468-200d-1f468-200d-1f467',
    '1f468-200d-1f468-200d-1f467-200d-1f466',
    '1f468-200d-1f468-200d-1f466-200d-1f466',
    '1f468-200d-1f468-200d-1f467-200d-1f467',
    '1f469-200d-1f469-200d-1f466',
    '1f469-200d-1f469-200d-1f467',
    '1f469-200d-1f469-200d-1f467-200d-1f466',
    '1f469-200d-1f469-200d-1f466-200d-1f466',
    '1f469-200d-1f469-200d-1f467-200d-1f467',
    '1f463',
    '1f440',
    '1f441-fe0f',
    '1f445',
    '1f444',
    '1f48b',
    '1f4a4',
    '1f453',
    '1f576-fe0f',
    '1f454',
    '1f455',
    '1f456',
    '1f457',
    '1f458',
    '1f459',
    '1f45a',
    '1f45b',
    '1f45c',
    '1f45d',
    '1f392',
    '1f45e',
    '1f45f',
    '1f460',
    '1f461',
    '1f462',
    '1f451',
    '1f452',
    '1f3a9',
    '1f393',
    '26d1-fe0f',
    '1f484',
    '1f48d',
    '1f302',
    '1f4bc',
  ],
  objects: [
    '2620-fe0f',
    '1f48c',
    '1f4a3',
    '1f573-fe0f',
    '1f6cd-fe0f',
    '1f4ff',
    '1f48e',
    '1f52a',
    '1f3fa',
    '1f5fa-fe0f',
    '1f488',
    '1f5bc-fe0f',
    '1f6ce-fe0f',
    '1f6aa',
    '1f6cc',
    '1f6cf-fe0f',
    '1f6cb-fe0f',
    '1f6bd',
    '1f6bf',
    '1f6c1',
    '231b-fe0f',
    '23f3',
    '231a-fe0f',
    '23f0',
    '23f1-fe0f',
    '23f2-fe0f',
    '1f570-fe0f',
    '1f321-fe0f',
    '26f1-fe0f',
    '1f388',
    '1f389',
    '1f38a',
    '1f38e',
    '1f38f',
    '1f390',
    '1f380',
    '1f381',
    '1f579-fe0f',
    '1f4ef',
    '1f399-fe0f',
    '1f39a-fe0f',
    '1f39b-fe0f',
    '1f4fb',
    '1f4f1',
    '1f4f2',
    '260e-fe0f',
    '1f4de',
    '1f4df',
    '1f4e0',
    '1f50b',
    '1f50c',
    '1f4bb',
    '1f5a5-fe0f',
    '1f5a8-fe0f',
    '2328-fe0f',
    '1f5b1-fe0f',
    '1f5b2-fe0f',
    '1f4bd',
    '1f4be',
    '1f4bf',
    '1f4c0',
    '1f3a5',
    '1f39e-fe0f',
    '1f4fd-fe0f',
    '1f4fa',
    '1f4f7',
    '1f4f8',
    '1f4f9',
    '1f4fc',
    '1f50d',
    '1f50e',
    '1f52c',
    '1f52d',
    '1f4e1',
    '1f56f-fe0f',
    '1f4a1',
    '1f526',
    '1f3ee',
    '1f4d4',
    '1f4d5',
    '1f4d6',
    '1f4d7',
    '1f4d8',
    '1f4d9',
    '1f4da',
    '1f4d3',
    '1f4d2',
    '1f4c3',
    '1f4dc',
    '1f4c4',
    '1f4f0',
    '1f5de-fe0f',
    '1f4d1',
    '1f516',
    '1f3f7-fe0f',
    '1f4b0',
    '1f4b4',
    '1f4b5',
    '1f4b6',
    '1f4b7',
    '1f4b8',
    '1f4b3',
    '2709-fe0f',
    '1f4e7',
    '1f4e8',
    '1f4e9',
    '1f4e4',
    '1f4e5',
    '1f4e6',
    '1f4eb',
    '1f4ea',
    '1f4ec',
    '1f4ed',
    '1f4ee',
    '1f5f3-fe0f',
    '270f-fe0f',
    '2712-fe0f',
    '1f58b-fe0f',
    '1f58a-fe0f',
    '1f58c-fe0f',
    '1f58d-fe0f',
    '1f4dd',
    '1f4c1',
    '1f4c2',
    '1f5c2-fe0f',
    '1f4c5',
    '1f4c6',
    '1f5d2-fe0f',
    '1f5d3-fe0f',
    '1f4c7',
    '1f4c8',
    '1f4c9',
    '1f4ca',
    '1f4cb',
    '1f4cc',
    '1f4cd',
    '1f4ce',
    '1f587-fe0f',
    '1f4cf',
    '1f4d0',
    '2702-fe0f',
    '1f5c3-fe0f',
    '1f5c4-fe0f',
    '1f5d1-fe0f',
    '1f512',
    '1f513',
    '1f50f',
    '1f510',
    '1f511',
    '1f5dd-fe0f',
    '1f528',
    '26cf-fe0f',
    '2692-fe0f',
    '1f6e0-fe0f',
    '1f5e1-fe0f',
    '2694-fe0f',
    '1f52b',
    '1f6e1-fe0f',
    '1f527',
    '1f529',
    '2699-fe0f',
    '1f5dc-fe0f',
    '2697-fe0f',
    '2696-fe0f',
    '1f517',
    '26d3-fe0f',
    '1f489',
    '1f48a',
    '1f6ac',
    '26b0-fe0f',
    '26b1-fe0f',
    '1f5ff',
    '1f6e2-fe0f',
    '1f52e',
    '1f6d2',
    '1f6a9',
    '1f38c',
    '1f3f4',
    '1f3f3-fe0f',
    '1f3f3-fe0f-200d-1f308',
  ],
  activity: [
    '1f47e',
    '1f574-fe0f',
    '1f93a',
    '26f7-fe0f',
    '1f3c2',
    '1f3cc-fe0f',
    '1f3aa',
    '1f3ad',
    '1f3a8',
    '1f3b0',
    '1f397-fe0f',
    '1f39f-fe0f',
    '1f3ab',
    '1f396-fe0f',
    '1f3c6',
    '1f3c5',
    '1f947',
    '1f948',
    '1f949',
    '26bd-fe0f',
    '26be-fe0f',
    '1f3c0',
    '1f3d0',
    '1f3c8',
    '1f3c9',
    '1f3be',
    '1f3b1',
    '1f3b3',
    '1f3cf',
    '1f3d1',
    '1f3d2',
    '1f3d3',
    '1f3f8',
    '1f94a',
    '1f94b',
    '1f945',
    '1f3af',
    '26f3-fe0f',
    '26f8-fe0f',
    '1f3a3',
    '1f3bd',
    '1f3bf',
    '1f3ae',
    '1f3b2',
    '1f3bc',
    '1f3a4',
    '1f3a7',
    '1f3b7',
    '1f3b8',
    '1f3b9',
    '1f3ba',
    '1f3bb',
    '1f941',
    '1f3ac',
    '1f3f9',
  ],
  nature: [
    '1f648',
    '1f649',
    '1f64a',
    '1f4a6',
    '1f4a8',
    '1f435',
    '1f412',
    '1f98d',
    '1f436',
    '1f415',
    '1f429',
    '1f43a',
    '1f98a',
    '1f431',
    '1f408',
    '1f981',
    '1f42f',
    '1f405',
    '1f406',
    '1f434',
    '1f40e',
    '1f98c',
    '1f984',
    '1f42e',
    '1f402',
    '1f403',
    '1f404',
    '1f437',
    '1f416',
    '1f417',
    '1f43d',
    '1f40f',
    '1f411',
    '1f410',
    '1f42a',
    '1f42b',
    '1f418',
    '1f98f',
    '1f42d',
    '1f401',
    '1f400',
    '1f439',
    '1f430',
    '1f407',
    '1f43f-fe0f',
    '1f987',
    '1f43b',
    '1f428',
    '1f43c',
    '1f43e',
    '1f983',
    '1f414',
    '1f413',
    '1f423',
    '1f424',
    '1f425',
    '1f426',
    '1f427',
    '1f54a-fe0f',
    '1f985',
    '1f986',
    '1f989',
    '1f438',
    '1f40a',
    '1f422',
    '1f98e',
    '1f40d',
    '1f432',
    '1f409',
    '1f433',
    '1f40b',
    '1f42c',
    '1f41f',
    '1f420',
    '1f421',
    '1f988',
    '1f419',
    '1f41a',
    '1f980',
    '1f990',
    '1f991',
    '1f98b',
    '1f40c',
    '1f41b',
    '1f41c',
    '1f41d',
    '1f41e',
    '1f577-fe0f',
    '1f578-fe0f',
    '1f982',
    '1f490',
    '1f338',
    '1f3f5-fe0f',
    '1f339',
    '1f940',
    '1f33a',
    '1f33b',
    '1f33c',
    '1f337',
    '1f331',
    '1f332',
    '1f333',
    '1f334',
    '1f335',
    '1f33e',
    '1f33f',
    '2618-fe0f',
    '1f340',
    '1f341',
    '1f342',
    '1f343',
    '1f344',
    '1f330',
    '1f30d',
    '1f30e',
    '1f30f',
    '1f311',
    '1f312',
    '1f313',
    '1f314',
    '1f315',
    '1f316',
    '1f317',
    '1f318',
    '1f319',
    '1f31a',
    '1f31b',
    '1f31c',
    '2600-fe0f',
    '1f31d',
    '1f31e',
    '2b50-fe0f',
    '1f31f',
    '2601-fe0f',
    '26c5-fe0f',
    '26c8-fe0f',
    '1f324-fe0f',
    '1f325-fe0f',
    '1f326-fe0f',
    '1f327-fe0f',
    '1f328-fe0f',
    '1f329-fe0f',
    '1f32a-fe0f',
    '1f32b-fe0f',
    '1f32c-fe0f',
    '2602-fe0f',
    '2614-fe0f',
    '26a1-fe0f',
    '2744-fe0f',
    '2603-fe0f',
    '26c4-fe0f',
    '2604-fe0f',
    '1f525',
    '1f4a7',
    '1f30a',
    '1f383',
    '1f384',
    '2728',
    '1f38b',
    '1f38d',
  ],
  travel: [
    '1f3ce-fe0f',
    '1f3cd-fe0f',
    '1f5fe',
    '1f3d4-fe0f',
    '26f0-fe0f',
    '1f30b',
    '1f5fb',
    '1f3d5-fe0f',
    '1f3d6-fe0f',
    '1f3dc-fe0f',
    '1f3dd-fe0f',
    '1f3de-fe0f',
    '1f3df-fe0f',
    '1f3db-fe0f',
    '1f3d7-fe0f',
    '1f3d8-fe0f',
    '1f3d9-fe0f',
    '1f3da-fe0f',
    '1f3e0',
    '1f3e1',
    '1f3e2',
    '1f3e3',
    '1f3e4',
    '1f3e5',
    '1f3e6',
    '1f3e8',
    '1f3e9',
    '1f3ea',
    '1f3eb',
    '1f3ec',
    '1f3ed',
    '1f3ef',
    '1f3f0',
    '1f492',
    '1f5fc',
    '1f5fd',
    '26ea-fe0f',
    '1f54c',
    '1f54d',
    '26e9-fe0f',
    '1f54b',
    '26f2-fe0f',
    '26fa-fe0f',
    '1f301',
    '1f303',
    '1f304',
    '1f305',
    '1f306',
    '1f307',
    '1f309',
    '1f30c',
    '1f3a0',
    '1f3a1',
    '1f3a2',
    '1f682',
    '1f683',
    '1f684',
    '1f685',
    '1f686',
    '1f687',
    '1f688',
    '1f689',
    '1f68a',
    '1f69d',
    '1f69e',
    '1f68b',
    '1f68c',
    '1f68d',
    '1f68e',
    '1f690',
    '1f691',
    '1f692',
    '1f693',
    '1f694',
    '1f695',
    '1f696',
    '1f697',
    '1f698',
    '1f699',
    '1f69a',
    '1f69b',
    '1f69c',
    '1f6b2',
    '1f6f4',
    '1f6f5',
    '1f68f',
    '1f6e3-fe0f',
    '1f6e4-fe0f',
    '26fd-fe0f',
    '1f6a8',
    '1f6a5',
    '1f6a6',
    '1f6a7',
    '2693-fe0f',
    '26f5-fe0f',
    '1f6f6',
    '1f6a4',
    '1f6f3-fe0f',
    '26f4-fe0f',
    '1f6e5-fe0f',
    '1f6a2',
    '2708-fe0f',
    '1f6e9-fe0f',
    '1f6eb',
    '1f6ec',
    '1f4ba',
    '1f681',
    '1f69f',
    '1f6a0',
    '1f6a1',
    '1f680',
    '1f6f0-fe0f',
    '1f320',
    '1f308',
    '1f386',
    '1f387',
    '1f391',
    '1f3c1',
  ],
  food: [
    '1f347',
    '1f348',
    '1f349',
    '1f34a',
    '1f34b',
    '1f34c',
    '1f34d',
    '1f34e',
    '1f34f',
    '1f350',
    '1f351',
    '1f352',
    '1f353',
    '1f95d',
    '1f345',
    '1f951',
    '1f346',
    '1f954',
    '1f955',
    '1f33d',
    '1f336-fe0f',
    '1f952',
    '1f95c',
    '1f35e',
    '1f950',
    '1f956',
    '1f95e',
    '1f9c0',
    '1f356',
    '1f357',
    '1f953',
    '1f354',
    '1f35f',
    '1f355',
    '1f32d',
    '1f32e',
    '1f32f',
    '1f959',
    '1f95a',
    '1f373',
    '1f958',
    '1f372',
    '1f957',
    '1f37f',
    '1f371',
    '1f358',
    '1f359',
    '1f35a',
    '1f35b',
    '1f35c',
    '1f35d',
    '1f360',
    '1f362',
    '1f363',
    '1f364',
    '1f365',
    '1f361',
    '1f366',
    '1f367',
    '1f368',
    '1f369',
    '1f36a',
    '1f382',
    '1f370',
    '1f36b',
    '1f36c',
    '1f36d',
    '1f36e',
    '1f36f',
    '1f37c',
    '1f95b',
    '2615-fe0f',
    '1f375',
    '1f376',
    '1f37e',
    '1f377',
    '1f378',
    '1f379',
    '1f37a',
    '1f37b',
    '1f942',
    '1f943',
    '1f37d-fe0f',
    '1f374',
    '1f944',
  ],
  flags: [
    '1f1e6-1f1e8',
    '1f1e6-1f1e9',
    '1f1e6-1f1ea',
    '1f1e6-1f1eb',
    '1f1e6-1f1ec',
    '1f1e6-1f1ee',
    '1f1e6-1f1f1',
    '1f1e6-1f1f2',
    '1f1e6-1f1f4',
    '1f1e6-1f1f6',
    '1f1e6-1f1f7',
    '1f1e6-1f1f8',
    '1f1e6-1f1f9',
    '1f1e6-1f1fa',
    '1f1e6-1f1fc',
    '1f1e6-1f1fd',
    '1f1e6-1f1ff',
    '1f1e7-1f1e6',
    '1f1e7-1f1e7',
    '1f1e7-1f1e9',
    '1f1e7-1f1ea',
    '1f1e7-1f1eb',
    '1f1e7-1f1ec',
    '1f1e7-1f1ed',
    '1f1e7-1f1ee',
    '1f1e7-1f1ef',
    '1f1e7-1f1f1',
    '1f1e7-1f1f2',
    '1f1e7-1f1f3',
    '1f1e7-1f1f4',
    '1f1e7-1f1f6',
    '1f1e7-1f1f7',
    '1f1e7-1f1f8',
    '1f1e7-1f1f9',
    '1f1e7-1f1fb',
    '1f1e7-1f1fc',
    '1f1e7-1f1fe',
    '1f1e7-1f1ff',
    '1f1e8-1f1e6',
    '1f1e8-1f1e8',
    '1f1e8-1f1e9',
    '1f1e8-1f1eb',
    '1f1e8-1f1ec',
    '1f1e8-1f1ed',
    '1f1e8-1f1ee',
    '1f1e8-1f1f0',
    '1f1e8-1f1f1',
    '1f1e8-1f1f2',
    '1f1e8-1f1f3',
    '1f1e8-1f1f4',
    '1f1e8-1f1f5',
    '1f1e8-1f1f7',
    '1f1e8-1f1fa',
    '1f1e8-1f1fb',
    '1f1e8-1f1fc',
    '1f1e8-1f1fd',
    '1f1e8-1f1fe',
    '1f1e8-1f1ff',
    '1f1e9-1f1ea',
    '1f1e9-1f1ec',
    '1f1e9-1f1ef',
    '1f1e9-1f1f0',
    '1f1e9-1f1f2',
    '1f1e9-1f1f4',
    '1f1e9-1f1ff',
    '1f1ea-1f1e6',
    '1f1ea-1f1e8',
    '1f1ea-1f1ea',
    '1f1ea-1f1ec',
    '1f1ea-1f1ed',
    '1f1ea-1f1f7',
    '1f1ea-1f1f8',
    '1f1ea-1f1f9',
    '1f1ea-1f1fa',
    '1f1eb-1f1ee',
    '1f1eb-1f1ef',
    '1f1eb-1f1f0',
    '1f1eb-1f1f2',
    '1f1eb-1f1f4',
    '1f1eb-1f1f7',
    '1f1ec-1f1e6',
    '1f1ec-1f1e7',
    '1f1ec-1f1e9',
    '1f1ec-1f1ea',
    '1f1ec-1f1eb',
    '1f1ec-1f1ec',
    '1f1ec-1f1ed',
    '1f1ec-1f1ee',
    '1f1ec-1f1f1',
    '1f1ec-1f1f2',
    '1f1ec-1f1f3',
    '1f1ec-1f1f5',
    '1f1ec-1f1f6',
    '1f1ec-1f1f7',
    '1f1ec-1f1f8',
    '1f1ec-1f1f9',
    '1f1ec-1f1fa',
    '1f1ec-1f1fc',
    '1f1ec-1f1fe',
    '1f1ed-1f1f0',
    '1f1ed-1f1f2',
    '1f1ed-1f1f3',
    '1f1ed-1f1f7',
    '1f1ed-1f1f9',
    '1f1ed-1f1fa',
    '1f1ee-1f1e8',
    '1f1ee-1f1e9',
    '1f1ee-1f1ea',
    '1f1ee-1f1f1',
    '1f1ee-1f1f2',
    '1f1ee-1f1f3',
    '1f1ee-1f1f4',
    '1f1ee-1f1f6',
    '1f1ee-1f1f7',
    '1f1ee-1f1f8',
    '1f1ee-1f1f9',
    '1f1ef-1f1ea',
    '1f1ef-1f1f2',
    '1f1ef-1f1f4',
    '1f1ef-1f1f5',
    '1f1f0-1f1ea',
    '1f1f0-1f1ec',
    '1f1f0-1f1ed',
    '1f1f0-1f1ee',
    '1f1f0-1f1f2',
    '1f1f0-1f1f3',
    '1f1f0-1f1f5',
    '1f1f0-1f1f7',
    '1f1f0-1f1fc',
    '1f1f0-1f1fe',
    '1f1f0-1f1ff',
    '1f1f1-1f1e6',
    '1f1f1-1f1e7',
    '1f1f1-1f1e8',
    '1f1f1-1f1ee',
    '1f1f1-1f1f0',
    '1f1f1-1f1f7',
    '1f1f1-1f1f8',
    '1f1f1-1f1f9',
    '1f1f1-1f1fa',
    '1f1f1-1f1fb',
    '1f1f1-1f1fe',
    '1f1f2-1f1e6',
    '1f1f2-1f1e8',
    '1f1f2-1f1e9',
    '1f1f2-1f1ea',
    '1f1f2-1f1eb',
    '1f1f2-1f1ec',
    '1f1f2-1f1ed',
    '1f1f2-1f1f0',
    '1f1f2-1f1f1',
    '1f1f2-1f1f2',
    '1f1f2-1f1f3',
    '1f1f2-1f1f4',
    '1f1f2-1f1f5',
    '1f1f2-1f1f6',
    '1f1f2-1f1f7',
    '1f1f2-1f1f8',
    '1f1f2-1f1f9',
    '1f1f2-1f1fa',
    '1f1f2-1f1fb',
    '1f1f2-1f1fc',
    '1f1f2-1f1fd',
    '1f1f2-1f1fe',
    '1f1f2-1f1ff',
    '1f1f3-1f1e6',
    '1f1f3-1f1e8',
    '1f1f3-1f1ea',
    '1f1f3-1f1eb',
    '1f1f3-1f1ec',
    '1f1f3-1f1ee',
    '1f1f3-1f1f1',
    '1f1f3-1f1f4',
    '1f1f3-1f1f5',
    '1f1f3-1f1f7',
    '1f1f3-1f1fa',
    '1f1f3-1f1ff',
    '1f1f4-1f1f2',
    '1f1f5-1f1e6',
    '1f1f5-1f1ea',
    '1f1f5-1f1eb',
    '1f1f5-1f1ec',
    '1f1f5-1f1ed',
    '1f1f5-1f1f0',
    '1f1f5-1f1f1',
    '1f1f5-1f1f2',
    '1f1f5-1f1f3',
    '1f1f5-1f1f7',
    '1f1f5-1f1f8',
    '1f1f5-1f1f9',
    '1f1f5-1f1fc',
    '1f1f5-1f1fe',
    '1f1f6-1f1e6',
    '1f1f7-1f1ea',
    '1f1f7-1f1f4',
    '1f1f7-1f1f8',
    '1f1f7-1f1fa',
    '1f1f7-1f1fc',
    '1f1f8-1f1e6',
    '1f1f8-1f1e7',
    '1f1f8-1f1e8',
    '1f1f8-1f1e9',
    '1f1f8-1f1ea',
    '1f1f8-1f1ec',
    '1f1f8-1f1ed',
    '1f1f8-1f1ee',
    '1f1f8-1f1ef',
    '1f1f8-1f1f0',
    '1f1f8-1f1f1',
    '1f1f8-1f1f2',
    '1f1f8-1f1f3',
    '1f1f8-1f1f4',
    '1f1f8-1f1f7',
    '1f1f8-1f1f8',
    '1f1f8-1f1f9',
    '1f1f8-1f1fb',
    '1f1f8-1f1fd',
    '1f1f8-1f1fe',
    '1f1f8-1f1ff',
    '1f1f9-1f1e6',
    '1f1f9-1f1e8',
    '1f1f9-1f1e9',
    '1f1f9-1f1eb',
    '1f1f9-1f1ec',
    '1f1f9-1f1ed',
    '1f1f9-1f1ef',
    '1f1f9-1f1f0',
    '1f1f9-1f1f1',
    '1f1f9-1f1f2',
    '1f1f9-1f1f3',
    '1f1f9-1f1f4',
    '1f1f9-1f1f7',
    '1f1f9-1f1f9',
    '1f1f9-1f1fb',
    '1f1f9-1f1fc',
    '1f1f9-1f1ff',
    '1f1fa-1f1e6',
    '1f1fa-1f1ec',
    '1f1fa-1f1f2',
    '1f1fa-1f1f8',
    '1f1fa-1f1fe',
    '1f1fa-1f1ff',
    '1f1fb-1f1e6',
    '1f1fb-1f1e8',
    '1f1fb-1f1ea',
    '1f1fb-1f1ec',
    '1f1fb-1f1ee',
    '1f1fb-1f1f3',
    '1f1fb-1f1fa',
    '1f1fc-1f1eb',
    '1f1fc-1f1f8',
    '1f1fd-1f1f0',
    '1f1fe-1f1ea',
    '1f1fe-1f1f9',
    '1f1ff-1f1e6',
    '1f1ff-1f1f2',
    '1f1ff-1f1fc',
  ],
};

export default emojiList;
